import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";
import type { LearnFAQ } from "@/pages/learn/learnShared";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puede alguien viajar conmigo para el tratamiento con SAINT®?",
    answer:
      "Sí. Un familiar, amigo o cuidador puede viajar con usted. Un acompañante es opcional: SAINT® no usa anestesia, así que no se necesita conductor. Muchos pacientes aprecian el apoyo emocional durante la semana de 5 días. Los acompañantes pueden esperar en la clínica o explorar el área.",
  },
  {
    question: "¿Necesito que alguien me lleve para SAINT®?",
    answer:
      "No. Como SAINT® no usa anestesia ni sedación, por lo general puede conducir usted mismo. No se requiere conductor. Esto difiere del ECT y SPRAVATO®, que sí lo requieren.",
  },
  {
    question: "¿Qué debe esperar mi cuidador o cónyuge durante SAINT®?",
    answer:
      "Su acompañante puede esperar en la clínica, explorar el área o regresar al hotel entre sesiones. Cada día ocupa la mayor parte del día por las 10 sesiones con descansos. Los acompañantes brindan apoyo emocional y ayudan con la logística. No se requiere cuidado médico.",
  },
];

export const esCanSomeoneTravel = makeEsArticle({
  slug: "can-someone-travel-with-me-for-saint-tms",
  title: "¿Puede alguien viajar conmigo para SAINT® TMS? | Neuro Wellness",
  description:
    "Sí: un familiar o acompañante puede viajar con usted para el tratamiento con SAINT®. Conozca qué deben esperar los acompañantes durante la semana de tratamiento.",
  h1: "¿Puede alguien viajar conmigo para SAINT® TMS?",
  breadcrumbLabel: "Acompañante en SAINT®",
  shortAnswer:
    "Sí, un familiar, amigo o cuidador puede viajar con usted para el tratamiento con SAINT® TMS. Como SAINT® no usa anestesia ni sedación, un acompañante es opcional: por lo general puede conducir usted mismo. Sin embargo, muchos pacientes aprecian tener un acompañante para apoyo durante la semana de tratamiento de 5 días. Los acompañantes pueden esperar en la clínica o explorar el área de Coral Springs durante las sesiones. Si viaja de fuera, su acompañante puede alojarse en el mismo hotel. No hay un requisito médico de acompañante, pero el apoyo emocional durante el tratamiento puede ser valioso.",
  keyTakeaways: [
    "Sí, un acompañante puede viajar con usted para SAINT®.",
    "Un acompañante es opcional: no hay requisito médico.",
    "Los acompañantes pueden esperar en la clínica o explorar el área.",
    "Muchos pacientes aprecian el apoyo emocional durante la semana.",
    "Los acompañantes pueden alojarse en el mismo hotel.",
  ],
  sections: [
    {
      heading: "Los acompañantes son bienvenidos",
      paragraphs: [
        "Un familiar, amigo o cuidador puede viajar con usted para el tratamiento con SAINT®. Como SAINT® no usa anestesia ni sedación, un acompañante no es médicamente necesario: por lo general puede conducir usted mismo y gestionar la semana de tratamiento de forma independiente. Sin embargo, muchos pacientes aprecian tener un acompañante para apoyo emocional, especialmente durante un tratamiento intensivo de 5 días.",
      ],
    },
    {
      heading: "Qué deben esperar los acompañantes",
      paragraphs: ["Durante la semana de tratamiento, su acompañante puede:"],
      list: [
        "Esperar en la clínica durante las sesiones (si hay espacio)",
        "Explorar Coral Springs y el sur de Florida entre sesiones",
        "Alojarse en el mismo hotel y compartir comidas",
        "Brindar apoyo emocional durante la semana intensiva",
        "Ayudar con la logística, las comidas y el transporte",
      ],
    },
    {
      heading: "No hay requisito médico",
      paragraphs: [
        "A diferencia del ECT o SPRAVATO®, que requieren un conductor por la anestesia o la disociación, SAINT® no requiere acompañante. Puede conducir usted mismo hacia y desde el tratamiento. Un acompañante es puramente opcional: algunos pacientes prefieren pasar el tratamiento solos, mientras que otros valoran el apoyo.",
        "[[Consulte nuestra guía de viaje|/es/saint-tms-travel]] para pacientes que se desplazan a Coral Springs.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
